/// <reference path="../../trp/services/globalisation.service.ts"/>
/// <reference path="../services/countryPicker.service.ts"/>
'use strict';

namespace ekh {

    type PointOfSale = TR.IPointOfSale;
    type Language = TR.ILanguage;
    type IGlobalisationService = TR.IGlobalisationService;
    type IRegionalContext = TR.IRegionalContext;
    let t = Date.now();

    class NavToolbar {

        activeContext: IRegionalContext;
        dropdownToggled: boolean = false;
        parentThis: any = this;

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            private globalisationService: IGlobalisationService,
            private signUpPopupService: any
        ) {
            globalisationService.getSelectedRegionalContext().then(regionalContext => {
                this.activeContext = regionalContext;
            });

            broker.subscribe('navToolbar', 'RegionalContextSelected', ev => {
                return this.activeContext;
            });

            $scope.$on('$destroy', () => {
                broker.unsubscribe('navToolbar');
            });

            this.idleLogout();
        }

        toggleCountryPicker(): void {
            this.dropdownToggled = !this.dropdownToggled;
        };

        openSignUpPopup() {
            this.signUpPopupService.showPopup();
        }

        idleLogout() {
            this.showPopup();
            window.onload = this.resetTimer;
            window.onmousemove = this.resetTimer;
            window.onmousedown = this.resetTimer;
            window.ontouchstart = this.resetTimer;
            window.ontouchmove = this.resetTimer;
            window.onclick = this.resetTimer;
            window.onkeydown = this.resetTimer;
            window.addEventListener('scroll', this.resetTimer, true);
        }

        public resetTimer() {
            t = Date.now();
        }

        /*this method used to show popup by calling "resetTimer" method. its a recursive method*/
        public showPopup() {
            let self = this;
            let d = Date.now();

            if (TRPCONFIG.Domain2.IsSubscribeModalAutoTriggerEnabled) {

                if ((d - t) > 10000
                && localStorage.getItem('popState') !== 'shown'
                && TRPCONFIG.searchState !== 'searching'
                && localStorage.getItem('subscriptionState') !== 'subscribed') {

                    this.openSignUpPopup();
                    localStorage.setItem('popState', 'shown');
                }

                setTimeout(function () {
                    if (TRPCONFIG.searchState === 'searching') {
                        t = Date.now();
                    }
                }.bind(this), 1000);
            }
            document.addEventListener('mouseleave', (event: MouseEvent )  => {
                if (TRPCONFIG.Domain2.IsSubscribeModalAutoTriggerEnabled) {
                    if ((event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth
                        || event.clientY >= window.innerHeight))
                    && localStorage.getItem('popState') !== 'shown'
                    && TRPCONFIG.searchState !== 'searching'
                    && localStorage.getItem('subscriptionState') !== 'subscribed') {
                        this.openSignUpPopup();
                        localStorage.setItem('popState', 'shown');
                    }
                }
            });

            if (TRPCONFIG.Domain2.IsSubscribeModalAutoTriggerEnabled) {
            setTimeout(function () {
                self.showPopup();
            }.bind(this), 10000);
            }

        }
    }

    angular
        .module('ekh')
        .directive('navToolbar', () => {
            return {
                restrict: 'E',
                scope: true,
                templateUrl: 'partials/home/directivetemplate?type=navtoolbar',
                controller: NavToolbar,
                controllerAs: 'nt'
            };
        });

}
